// 9:16 → 4:5 safe-zone preview overlay (Task #819).
//
// Every 9:16 ad must keep key content inside the centered 4:5 region (the
// top/bottom ~14.8% bands are background-only). This overlay dims those bands
// on a 9:16 preview so the team can verify compliance at a glance before
// downloading. The band size derives from the shared aspect-ratio source of
// truth, so it can never drift from the render-side directive.
//
// Usage: mount inside a `relative` container whose box matches the 9:16 image
// exactly (same aspect ratio, no object-cover cropping) — otherwise the bands
// won't line up with the real pixels.
import { SAFE_ZONE_BAND_FRACTION } from "@shared/aspectRatios";
import { Button } from "@/components/ui/button";
import { Frame } from "lucide-react";

const BAND_PCT = `${(SAFE_ZONE_BAND_FRACTION * 100).toFixed(2)}%`;

export function SafeZoneOverlay() {
  return (
    <div
      className="absolute inset-0 pointer-events-none z-10"
      aria-hidden="true"
      data-testid="overlay-safe-zone"
    >
      <div
        className="absolute inset-x-0 top-0 bg-black/45 border-b border-dashed border-white/80"
        style={{ height: BAND_PCT }}
      />
      <div
        className="absolute inset-x-0 bottom-0 bg-black/45 border-t border-dashed border-white/80"
        style={{ height: BAND_PCT }}
      >
        <span className="absolute bottom-1 left-1/2 -translate-x-1/2 rounded bg-black/60 px-1.5 py-0.5 text-[9px] font-medium leading-none text-white/90 whitespace-nowrap">
          4:5 safe zone
        </span>
      </div>
    </div>
  );
}

export function SafeZoneToggle({
  active,
  onToggle,
  className,
}: {
  active: boolean;
  onToggle: () => void;
  className?: string;
}) {
  return (
    <Button
      type="button"
      variant={active ? "default" : "outline"}
      size="sm"
      onClick={onToggle}
      className={`h-7 rounded-full text-[11px] ${className ?? ""}`}
      aria-pressed={active}
      title="Toggle the 4:5 safe-zone guides on 9:16 previews"
      data-testid="button-toggle-safe-zone"
    >
      <Frame className="h-3 w-3 mr-1" />
      Safe zone
    </Button>
  );
}
